import { TimelineMax } from 'gsap'

export default {
  methods: {
    backgroundAnimation (containerId, staggerTime, fadeOutDelay, startEvent) {
      const tl = new TimelineMax({ paused: true })
      tl.staggerFrom(`#${containerId} > img`, 0.4, { opacity: 0 }, staggerTime)
      tl.to(`#${containerId} > img`, 0.4, { opacity: 0, delay: fadeOutDelay })
      this.$root.$on(startEvent, () => {
        tl.play()
      })
    }
  }
}
